// constants.js
const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

// pubsub.js
let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    const promises = subscribers[eventName]
      .map((callback) => callback(data))
    return Promise.all(promises);
  } else {
    return Promise.resolve()
  }
}

window.merakiUtils = {
  isLoadedAfterFirstScreen: false, // 未加载资源
  lazyImages: Array.from(document.querySelectorAll('img.lazy-load[data-src]')),
  lazyVideos: Array.from(document.querySelectorAll('video.lazy-video-load')),
  lazyYoutubeVideos: Array.from(document.querySelectorAll('iframe.lazy-youtube-load')),
  loadThreshold: 1500, // 提前1500px加载，提升体验
  submitCountryForm: function (country = '', returnHref = '', locale_code='', currencyCode = '') {
    // 通过 shopify 内部 api 的 /localization 实现跳转
    // 通过 form 表单实现跳转
    const host = 'https://www.merakitech.com'
    const host_local = '/localization'
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = `${host}${host_local}`;
    form.acceptCharset = 'UTF-8';
    form.style.display = 'none';

    // const HeaderCountryFormDom = document.querySelector('#HeaderCountryForm')
    // if (HeaderCountryFormDom) {
    //   const formAction = HeaderCountryFormDom.getAttribute('action');
    //   if (formAction) {
    //     form.action = `${host}${formAction}`;
    //   }
    // }

    returnHref = this.formatReturnHref(returnHref, country, currencyCode)

    const formData = [
      { name: 'form_type', value: 'localization' },
      { name: 'utf8', value: '✓' },
      { name: '_method', value: 'put' },
      { name: 'return_to', value: returnHref },
      { name: 'country_filter', value: '' },
      { name: 'country_code', value: country },
      { name: 'locale_code', value: locale_code }
    ];

    formData.forEach(item => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = item.name;
      input.value = item.value;
      form.appendChild(input);
    });

    document.body.appendChild(form);

    form.submit();
    setTimeout(() => document.body.removeChild(form), 100);
  },
  formatReturnHref: function (returnHref = '', country = '', currencyCode = '') {
    // 根据国家代码格式化返回链接
    const defaultHref = '/products/meraki-espresso-machine'
    const caHref = '/products/espresso-machine'
    const ausHref = '/products/meraki-espresso-machine_'
    const euHref = '/products/meraki-espresso-machine-eu'

    const entryParams = '?utm_source=eu.merakitech.com&utm_medium=referral&utm_campaign=geo_redirect';

    const isCountry = country && country.toLocaleUpperCase && country.toLocaleUpperCase() // 判断国家代码是否有效且转换为大写

    if (isCountry === 'CA') {
      // 替换链接中的路径为加拿大路径
      if (!returnHref.includes(caHref)) {
        if (returnHref.includes(ausHref)) {
          returnHref = returnHref.replace(ausHref, caHref);
        } else if (returnHref.includes(euHref)) {
          returnHref = returnHref.replace(euHref, caHref);
        } else if (returnHref.includes(defaultHref)) {
          returnHref = returnHref.replace(defaultHref, caHref);
        }
      }
      returnHref += entryParams;
    } else if (isCountry === 'AU') {
      // 替换链接中的路径为澳大利亚路径
      if (!returnHref.includes(ausHref)) {
        if (returnHref.includes(caHref)) {
          returnHref = returnHref.replace(caHref, ausHref);
        } else if (returnHref.includes(euHref)) {
          returnHref = returnHref.replace(euHref, ausHref);
        }else if (returnHref.includes(defaultHref)) {
          returnHref = returnHref.replace(defaultHref, ausHref);
        }
      }
      returnHref += entryParams;
    } else if (isCountry === 'US') {
      // 替换链接中的路径为US路径
      if (returnHref.includes(caHref)) {
        returnHref = returnHref.replace(caHref, defaultHref);
      } else if (returnHref.includes(euHref)) {
        returnHref = returnHref.replace(euHref, defaultHref);
      } else if (returnHref.includes(ausHref)) {
        returnHref = returnHref.replace(ausHref, defaultHref);
      }
      returnHref += entryParams;
    } else {
      // 如果是其它的国家的url要转为eu的路径
      if (returnHref.includes(caHref)) {
        returnHref = returnHref.replace(caHref, euHref);
      } else if (returnHref.includes(ausHref)) {
        returnHref = returnHref.replace(ausHref, euHref);
      } else if (!returnHref.includes(euHref) && returnHref.includes(defaultHref)) {
        returnHref = returnHref.replace(defaultHref, euHref);
      }
    }

    return returnHref
  },
  // 过滤重定向链接，应该同一个产品的链接不一样，需要进行处理
  filterRedirectPath: function (redirectPath = '') {
    redirectPath = redirectPath.replace(window.Shopify.routes.root, '/')
    return redirectPath
  },
  loadVisibleResource: function () {
    // 懒加载资源
    window.merakiUtils.lazyImages.forEach(img => {
      if (img.classList.contains('lazy-load')) {
        if (window.merakiUtils.isInViewPort(img)) {
          window.merakiUtils.loadImage(img);
        }
      }
    });

    window.merakiUtils.lazyVideos.forEach(video => {
      if (video.classList.contains('lazy-video-load')) {
        if (window.merakiUtils.isInViewPort(video)) {
          window.merakiUtils.loadVideo(video);
        }
      }
    });

    window.merakiUtils.lazyYoutubeVideos.forEach(video => {
      if (video && video.classList.contains('lazy-youtube-load')) {
        if (window.merakiUtils.isInViewPort(video)) {
          window.merakiUtils.loadYoutubeVideo(video);
        }
      }
    });

    window.merakiUtils.loadResourceAfterFirstScreen()
  },
  // 节流函数：降低scroll触发频率（每200ms执行一次）
  throttle: function (fn, delay = 200) {
    let timer = null;
    return function() {
      if (!timer) {
        timer = setTimeout(() => {
          fn.apply(this, arguments);
          timer = null;
        }, delay);
      }
    };
  },
  // 判断资源是否在可视区（含提前加载距离）
  isInViewPort: function (media) {
    let loadThreshold = window.innerHeight || (document.documentElement && document.documentElement.clientHeight);
    loadThreshold = loadThreshold ? loadThreshold : window.merakiUtils.loadThreshold
    const rect = media.getBoundingClientRect();
    return (
      rect.top <= (window.innerHeight || document.documentElement.clientHeight) + loadThreshold &&
      rect.bottom >= -loadThreshold
    );
    //  &&
    //   rect.left <= (window.innerWidth || document.documentElement.clientWidth) + loadThreshold &&
    //   rect.right >= -loadThreshold
  },
  // 加载单张图片
  loadImage: function (img) {
    const isNone = window.getComputedStyle(img).display === 'none';
    if (!isNone) {
      const pictureNode = img.closest('picture')
      if (pictureNode) {
        const sources = pictureNode.querySelectorAll('source')
        if (sources && sources.length > 0) {
          sources.forEach((source) => {
            const srcset = source.getAttribute('data-srcset');
            if (srcset) {
              source.srcset = source.getAttribute('data-srcset');
              source.removeAttribute('data-srcset');
            }
          })
        }
      }

      img.src = img.getAttribute('data-src');
      const srcset = img.getAttribute('data-srcset');
      if (srcset) {
        img.srcset = srcset;
        img.removeAttribute('data-srcset');
      }
      img.removeAttribute('data-src');
      img.classList.remove('lazy-load');
    }
    // 添加加载完成动画
    // img.style.opacity = '1';
  },
  // 加载单个视频
  loadVideo: function (videoDom) {
    const isNone = window.getComputedStyle(videoDom).display === 'none';
    if (!isNone) {
      videoDom.poster = videoDom.getAttribute('data-poster');
      const sourceDom = videoDom.querySelector('source')
      if (sourceDom) {
        sourceDom.src = sourceDom.getAttribute('data-src');
        videoDom.load()
      }
      videoDom.removeAttribute('data-poster');
      videoDom.classList.remove('lazy-video-load');
    }
  },
  // 加载单个youtube视频
  loadYoutubeVideo: function (videoDom) {
    const isNone = window.getComputedStyle(videoDom).display === 'none';
    if (!isNone) {
      videoDom.src = videoDom.getAttribute('data-youtube-lazy-src');
      videoDom.removeAttribute('data-youtube-lazy-src');
      videoDom.classList.remove('lazy-youtube-load');
    }
  },
  // 首屏以后再加载资源
  loadResourceAfterFirstScreen: function () {
    if (window.merakiUtils.isLoadedAfterFirstScreen) return;
    // 当前滚动距离（兼容不同浏览器）
    const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;

    if (scrollTop < 50) return;

    // 判定：滚动过首屏 + 未加载过资源
    if (!window.merakiUtils.isLoadedAfterFirstScreen) {
      window.merakiUtils.isLoadedAfterFirstScreen = true;

      window.dispatchEvent(new CustomEvent("CustomLoad"));

      document.querySelectorAll("script[type='text/lazyload']").forEach(originalScript => {
        const newScript = document.createElement('script');
        if (originalScript.dataset.src) {
          newScript.src = originalScript.dataset.src;
        }
        for (const attr of originalScript.attributes) {
          if (attr.name !== 'type' && attr.name !== 'data-src') {
            newScript.setAttribute(attr.name, attr.value);
          }
        }
        newScript.type = originalScript.dataset.type || 'text/javascript';
        originalScript.parentNode.replaceChild(newScript, originalScript);
      });
      const lazyScriptdDom = document.querySelectorAll('[data-script-src]');
      lazyScriptdDom.forEach(scriptSrc => {
        scriptSrc.src = scriptSrc.getAttribute('data-script-src');
        scriptSrc.removeAttribute('data-script-src');
      });

      // (function(c,l,a,r,i,t,y){
      //   c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
      //   t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
      //   y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
      // })(window, document, "clarity", "script", "ux6kwgymte");
    }
  },
  // 瞄点跳转
  scrollToAnchor: function () {
    // 导航高度（根据店铺固定导航调整，避免遮挡锚点）
    const currentHash = window.location.hash
    if (!currentHash) return;
    const navHeight = document.querySelector('.header').innerHeight || 120;
    // 多次尝试查找目标元素（适配动态加载）
    const maxAttempts = 10; // 最多尝试10次
    let attempts = 0;
    let timer = null
    const checkAndScroll = () => {
      clearTimeout(timer)
      attempts++;
      const target = document.querySelector(currentHash);
      if (target) {
        // 跳转到锚点，避开导航遮挡
        window.scrollTo({
          top: target.offsetTop - navHeight,
          behavior: 'smooth' // 平滑滚动，可选
        });
        return;
      }
      // 未找到目标元素，继续尝试（每200ms一次）
      if (attempts < maxAttempts) {
        timer = setTimeout(checkAndScroll, 200);
      }
    };
    checkAndScroll()
  },
  regionSelectorKey: 'region-selector-success',
  regionSelectorTimeKey: 'region-selector-time',
  localStorageSet (value = 'true') {
    localStorage.setItem(window.merakiUtils.regionSelectorKey, value) 
    localStorage.setItem(window.merakiUtils.regionSelectorTimeKey, Date.now()) 
  },
  clearExpiredLocalStorage (TWO_DAYS = 2 * 24 * 60 * 60 * 1000) {
    const now = Date.now();
    const cacheStrKey = localStorage.getItem(window.merakiUtils.regionSelectorKey);
    const cacheStr = localStorage.getItem(window.merakiUtils.regionSelectorTimeKey);
    if ((!cacheStr || !cacheStrKey) || cacheStr && now - cacheStr > TWO_DAYS) {
      localStorage.removeItem(window.merakiUtils.regionSelectorKey);
      localStorage.removeItem(window.merakiUtils.regionSelectorTimeKey);
      return true
    }
    return false
  },
  // 自动弹出地区选择器
  autoOpenRegionSelector () {
    if (!window.merakiUtils.clearExpiredLocalStorage || !window.merakiUtils.clearExpiredLocalStorage()) return false

    let width;
    if (window.innerWidth) {
      width = window.innerWidth;
    } 
    else if (document.documentElement && document.documentElement.clientWidth) {
      width = document.documentElement.clientWidth;
    } 
    else if (document.body) {
      width = document.body.clientWidth;
    }
    if (window.innerWidth && document.documentElement.clientWidth) {
      const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
      width = width - scrollbarWidth;
    }

    if (width > 1100) {
      if (window.openLocaleModal) {
        window.openLocaleModal()
      }
    } else {
      if (window.mobileModalInstance && window.mobileModalInstance.localeSelectorModalTrigger) {
        window.mobileModalInstance.localeSelectorModalTrigger.click()
      }
    }
  },
  // 全局绑定 IntersectionObserver 实例
  lazyObserver: (() => {
    let observer = null;

    const createObserver = () => {
      // 配置项：rootMargin提前N px触发（元素即将进入视口时就初始化，无感知）
      const ViewportHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
      const observerOptions = {
        root: null, // 根容器为视口（document.viewport）
        rootMargin: `${ViewportHeight * 0.3}px 0px`, // 上下各扩展50px，提前/延后判断
        threshold: 0 // 元素只要有1px进入视口就触发回调
      };
      return new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const component = entry.target;
            // 执行组件初始化
            if (typeof component.init === 'function') {
              component.init();
            }
            // 初始化后取消观察（只执行一次）
            observer.unobserve(component);
          }
        });
      }, observerOptions);
    }

    return {
      observe(component) {
        if (!observer) observer = createObserver();
        observer.observe(component)
      }
    }
  })()
}
// global.js
function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
    ),
  );
}

class SectionId {
  static #separator = "__";

  // for a qualified section id (e.g. 'template--22224696705326__main'), return just the section id (e.g. 'template--22224696705326')
  static parseId(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[0];
  }

  // for a qualified section id (e.g. 'template--22224696705326__main'), return just the section name (e.g. 'main')
  static parseSectionName(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[1];
  }

  // for a section id (e.g. 'template--22224696705326') and a section name (e.g. 'recommended-products'), return a qualified section id (e.g. 'template--22224696705326__recommended-products')
  static getIdForSection(sectionId, sectionName) {
    return `${sectionId}${SectionId.#separator}${sectionName}`;
  }
}

class HTMLUpdateUtility {
  /**
   * Used to swap an HTML node with a new node.
   * The new node is inserted as a previous sibling to the old node, the old node is hidden, and then the old node is removed.
   *
   * The function currently uses a double buffer approach, but this should be replaced by a view transition once it is more widely supported https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API
   */
  static viewTransition(
    oldNode,
    newContent,
    preProcessCallbacks = [],
    postProcessCallbacks = [],
  ) {
    preProcessCallbacks?.forEach((callback) => callback(newContent));

    const newNodeWrapper = document.createElement("div");
    HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
    const newNode = newNodeWrapper.firstChild;

    // dedupe IDs
    const uniqueKey = Date.now();
    oldNode.querySelectorAll("[id], [form]").forEach((element) => {
      element.id && (element.id = `${element.id}-${uniqueKey}`);
      element.form &&
        element.setAttribute(
          "form",
          `${element.form.getAttribute("id")}-${uniqueKey}`,
        );
    });

    oldNode.parentNode.insertBefore(newNode, oldNode);
    oldNode.style.display = "none";

    postProcessCallbacks?.forEach((callback) => callback(newNode));

    setTimeout(() => oldNode.remove(), 500);
  }

  // Sets inner HTML and reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
  static setInnerHTML(element, html) {
    element.innerHTML = html;
    element.querySelectorAll("script").forEach((oldScriptTag) => {
      const newScriptTag = document.createElement("script");
      Array.from(oldScriptTag.attributes).forEach((attribute) => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === "INPUT" &&
    ["search", "text", "email", "url"].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true,
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*",
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });
    this.input.addEventListener("change", this.onInputChange.bind(this));
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this)),
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.quantityUpdate,
      this.validateQtyRules.bind(this),
    );
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    if (event.target.name === "plus") {
      if (
        parseInt(this.input.dataset.min) > parseInt(this.input.step) &&
        this.input.value == 0
      ) {
        this.input.value = this.input.dataset.min;
      } else {
        this.input.stepUp();
      }
    } else {
      this.input.stepDown();
    }

    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);

    if (
      this.input.dataset.min === previousValue &&
      event.target.name === "minus"
    ) {
      this.input.value = parseInt(this.input.min);
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle(
        "disabled",
        parseInt(value) <= parseInt(this.input.min),
      );
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle("disabled", value >= max);
    }
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options,
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid,
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this),
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this)),
    );
    this.querySelectorAll(
      "button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button):not(.meraki-locale-mobile-trigger)",
    ).forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this)),
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector("summary"),
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest(".has-submenu");
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button"),
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus,
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);

      if (window.matchMedia("(max-width: 990px)")) {
        document.documentElement.style.setProperty(
          "--viewport-height",
          `${window.innerHeight}px`,
        );
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        parentMenuElement && parentMenuElement.classList.add("submenu-open");
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              "transitionend",
              addTrapFocus,
            );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening");
    });
    this.mainDetailsToggle
      .querySelectorAll(".submenu-open")
      .forEach((submenu) => {
        submenu.classList.remove("submenu-open");
      });
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`,
    );
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent)
      elementToFocus?.setAttribute("aria-expanded", false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest(".submenu-open");
    parentMenuElement && parentMenuElement.classList.remove("submenu-open");
    detailsElement.classList.remove("menu-opening");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary"),
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector(".section-header");
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper").classList.contains(
        "header-wrapper--border-bottom",
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`,
    );
    this.header.classList.add("menu-open");

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    window.addEventListener("resize", this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    // 先移除 menu-open 类，让 header 切换与 drawer 关闭同步
    this.header.classList.remove("menu-open");
    document.body.classList.remove("menu-open");
    super.closeMenuDrawer(event, elementToFocus);
    window.removeEventListener("resize", this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        "--header-bottom-position",
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`,
      );
    document.documentElement.style.setProperty(
      "--viewport-height",
      `${window.innerHeight}px`,
    );
  };
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this, false),
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    this.dataset.section = this.closest(".shopify-section").id.replace(
      "shopify-section-",
      "",
    );
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class BulkModal extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      if (this.innerHTML.trim() === "") {
        const productUrl = this.dataset.url.split("?")[0];
        fetch(`${productUrl}?section_id=bulk-quick-order-list`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(
              responseText,
              "text/html",
            );
            const sourceQty = html.querySelector(
              ".quick-order-list-container",
            ).parentNode;
            this.innerHTML = sourceQty.innerHTML;
          })
          .catch((e) => {
            console.error(e);
          });
      }
    };

    new IntersectionObserver(handleIntersection.bind(this)).observe(
      document.querySelector(
        `#QuickBulk-${this.dataset.productId}-${this.dataset.sectionId}`,
      ),
    );
  }
}

customElements.define("bulk-modal", BulkModal);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(
          true,
        ),
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe"),
      );
      if (focus) deferredElement.focus();
      if (
        deferredElement.nodeName == "VIDEO" &&
        deferredElement.getAttribute("autoplay")
      ) {
        // force autoplay for safari
        deferredElement.play();
      }

      // Workaround for safari iframe bug
      const formerStyle = deferredElement.getAttribute("style");
      deferredElement.setAttribute("style", "display: block;");
      window.setTimeout(() => {
        deferredElement.setAttribute("style", formerStyle);
      }, 0);
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));

    this.addPaginationBulletsListeners();

    // 注释掉自动跳转到变体特色媒体的逻辑
    // const mediaGallery = document.querySelector(`media-gallery`);
    // const selectMediaId = mediaGallery.dataset.selectMediaId;
    // const activeSlide = Array.from(this.sliderItems).find((slide) =>
    //   slide.dataset.mediaId.includes(selectMediaId),
    // );
    // if (activeSlide) this.goToSlide(activeSlide.dataset.index);

    subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      if (!event.data.variant.featured_media) return;
      const mediaId = `${event.data.sectionId}-${event.data.variant.featured_media.id}`;
      const activeSlide = this.querySelector(`[data-media-id="${mediaId}"]`);
      if (activeSlide && activeSlide.dataset) {
        this.goToSlide(activeSlide.dataset.index);
      }
    });
  }

  addPaginationBulletsListeners() {
    const paginationBullets = this.querySelectorAll(
      ".slider-pagination-bullet",
    );
    paginationBullets.forEach((bullet, index) => {
      bullet.onclick = () => {
        this.goToSlide(index + 1);
      };
    });
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0,
    );
    if (this.sliderItemsToShow.length < 2) {
      this.sliderItemOffset = 0;
      return;
    }
    this.sliderItemOffset = this.sliderItemsToShow[0].clientWidth;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
        this.sliderItemOffset,
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    const paginationBullets = this.querySelectorAll(
      ".slider-pagination-bullet",
    );
    paginationBullets.forEach((bullet, index) => {
      if (index + 1 === this.currentPage) {
        bullet.classList.add("is-active");
      } else {
        bullet.classList.remove("is-active");
      }
    });

    if (this.currentPage != previousPage) {
      const currentSliderItem = this.sliderItemsToShow[this.currentPage - 1];
      const prevSliderItem = this.sliderItemsToShow[this.currentPage - 2];
      const nextSliderItem = this.sliderItemsToShow[this.currentPage];
      this.loadingLazyImage(currentSliderItem)
      this.loadingLazyImage(prevSliderItem)
      this.loadingLazyImage(nextSliderItem)

      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        }),
      );
    }

    if (this.enableSliderLooping) return;

    if (
      this.isSlideVisible(this.sliderItemsToShow[0]) &&
      this.slider.scrollLeft === 0
    ) {
      this.prevButton.setAttribute("disabled", "disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (
      this.isSlideVisible(
        this.sliderItemsToShow[this.sliderItemsToShow.length - 1],
      )
    ) {
      this.nextButton.setAttribute("disabled", "disabled");
    } else {
      this.nextButton.removeAttribute("disabled");
    }

    this.addPaginationBulletsListeners();
  }

  loadingLazyImage(lazySliderItem) {
    if (lazySliderItem) {
      let lazyItemImgDom = lazySliderItem.querySelector(".image-magnify-hover")
      if (!lazyItemImgDom) {
        lazyItemImgDom = lazySliderItem.querySelector(".image-magnify-lightbox")
      }
      const dataLazySrc = lazyItemImgDom?.getAttribute("data-lazy-src");
      const dataLazySrcset = lazyItemImgDom?.getAttribute("data-lazy-srcset");
      if (lazyItemImgDom && dataLazySrc) {
        this.createLazyImage(dataLazySrc, dataLazySrcset, ({newScr, newSrcset}) => {
          lazyItemImgDom.setAttribute("src", newScr);
          lazyItemImgDom.removeAttribute("data-lazy-src");
          if (newSrcset) {
            lazyItemImgDom.setAttribute("srcset", newSrcset);
            lazyItemImgDom.removeAttribute("data-lazy-srcset");
          }
        })
      }
    }
  }

  createLazyImage(src, srcset, fn) {
    const overlayImage = document.createElement('img');
    overlayImage.style.display = 'none';
    overlayImage.setAttribute('src', src);
    if (srcset) {
      overlayImage.setAttribute('srcset', srcset);
    }
    document.body.appendChild(overlayImage);
    overlayImage.onload = () => {
      const newScr = overlayImage.getAttribute('src');
      const newSrcset = overlayImage.getAttribute('srcset');
      fn({newScr, newSrcset});
      overlayImage.remove();
    };
    overlayImage.onerror = () => {
      const newScr = overlayImage.getAttribute('src');
      const newSrcset = overlayImage.getAttribute('srcset');
      fn({newScr, newSrcset});
      overlayImage.remove();
    };
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }

  goToSlide(page) {
    if (!this.sliderItemOffset || isNaN(this.sliderItemOffset)) {
      this.initPages();
    }
    let slideScrollPosition = 0;
    if (this.sliderItemOffset && !isNaN(this.sliderItemOffset)) {
      slideScrollPosition = (page - 1) * this.sliderItemOffset;
    }
    this.setSlidePosition(slideScrollPosition);
  }
}

customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector(".slider-buttons");
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    const slideshowSlides = this.querySelectorAll(".slideshow__slide");
    if (slideshowSlides && slideshowSlides.length < 2) return;

    this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector(".announcement-bar-slider");
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll(".slider-counter__link"),
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener("click", this.linkToSlide.bind(this)),
    );
    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia(
        "(prefers-reduced-motion: reduce)",
      );
      this.reducedMotion.addEventListener("change", () => {
        if (this.slider.getAttribute("data-autoplay") === "true")
          this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          "click",
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true },
        );
      });
    }

    if (this.slider.getAttribute("data-autoplay") === "true")
      this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener("mouseover", this.focusInHandling.bind(this));
    this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
    this.addEventListener("focusin", this.focusInHandling.bind(this));
    this.addEventListener("focusout", this.focusOutHandling.bind(this));

    if (this.querySelector(".slideshow__autoplay")) {
      this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
      this.sliderAutoplayButton.addEventListener(
        "click",
        this.autoPlayToggle.bind(this),
      );
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked
        ? this.pause()
        : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === "previous") {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === "next") {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
    this.prevButton.removeAttribute("disabled");

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove("slider-counter__link--active");
      link.removeAttribute("aria-current");
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add(
      "slider-counter__link--active",
    );
    this.sliderControlButtons[this.currentPage - 1].setAttribute(
      "aria-current",
      true,
    );
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton ||
        this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (
      !this.reducedMotion.matches &&
      !this.announcementBarArrowButtonWasClicked
    ) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton ||
        this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute("aria-live", "off");
    clearInterval(this.autoplay);
    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed,
    );
  }

  pause() {
    this.slider.setAttribute("aria-live", "polite");
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.playSlideshow,
      );
    } else {
      this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.pauseSlideshow,
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll("a");
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute("tabindex");
          });
        item.setAttribute("aria-hidden", "false");
        item.removeAttribute("tabindex");
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute("tabindex", "-1");
          });
        item.setAttribute("aria-hidden", "true");
        item.setAttribute("tabindex", "-1");
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = "next") {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === "next" ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = "announcement-bar-slider--fade-in";
    const animationClassOut = "announcement-bar-slider--fade-out";

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext =
      (button === "next" && !isLastSlide) ||
      (button === "previous" && isFirstSlide);
    const direction = shouldMoveNext ? "next" : "previous";

    if (currentSlide && currentSlide.classList) {
      currentSlide.classList.add(`${animationClassOut}-${direction}`);
    }
    if (nextSlide && nextSlide.classList) {
      nextSlide.classList.add(`${animationClassIn}-${direction}`);
    }

    setTimeout(() => {
      if (currentSlide && currentSlide.classList) {
        currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      }
      if (nextSlide && nextSlide.classList) {
        nextSlide.classList.remove(`${animationClassIn}-${direction}`);
      }
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) +
          1 -
          this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slideshow-component", SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener("change", (event) => {
      const target = this.getInputForEventTarget(event.target);
      this.updateSelectionMetadata(event);

      publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
        data: {
          event,
          target,
          selectedOptionValues: this.selectedOptionValues,
        },
      });
    });
  }

  updateSelectionMetadata({ target }) {
    const { value, tagName } = target;

    if (tagName === "SELECT" && target.selectedOptions.length) {
      Array.from(target.options)
        .find((option) => option.getAttribute("selected"))
        .removeAttribute("selected");
      target.selectedOptions[0].setAttribute("selected", "selected");

      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = target
        .closest(".product-form__input")
        .querySelector("[data-selected-value] > .swatch");
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty(
          "--swatch--background",
          swatchValue,
        );
        selectedDropdownSwatchValue.classList.remove("swatch--unavailable");
      } else {
        selectedDropdownSwatchValue.style.setProperty(
          "--swatch--background",
          "unset",
        );
        selectedDropdownSwatchValue.classList.add("swatch--unavailable");
      }

      selectedDropdownSwatchValue.style.setProperty(
        "--swatch-focal-point",
        target.selectedOptions[0].dataset.optionSwatchFocalPoint || "unset",
      );
    } else if (tagName === "INPUT" && target.type === "radio") {
      const selectedSwatchValue = target
        .closest(`.product-form__input`)
        .querySelector("[data-selected-value]");
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  getInputForEventTarget(target) {
    return target.tagName === "SELECT" ? target.selectedOptions[0] : target;
  }

  get selectedOptionValues() {
    return Array.from(
      this.querySelectorAll("select option[selected], fieldset input:checked"),
    ).map(({ dataset }) => dataset.optionValueId);
  }
}

customElements.define("variant-selects", VariantSelects);

class ProductRecommendations extends HTMLElement {
  observer = undefined;

  constructor() {
    super();
  }

  connectedCallback() {
    this.initializeRecommendations(this.dataset.productId);
  }

  initializeRecommendations(productId) {
    this.observer?.unobserve(this);
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.loadRecommendations(productId);
      },
      { rootMargin: "0px 0px 400px 0px" },
    );
    this.observer.observe(this);
  }

  loadRecommendations(productId) {
    fetch(
      `${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`,
    )
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement("div");
        html.innerHTML = text;
        const recommendations = html.querySelector("product-recommendations");

        if (recommendations?.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }

        if (
          !this.querySelector("slideshow-component") &&
          this.classList.contains("complementary-products")
        ) {
          this.remove();
        }

        if (html.querySelector(".grid__item")) {
          this.classList.add("product-recommendations--loaded");
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }
}

customElements.define("product-recommendations", ProductRecommendations);

class AccountIcon extends HTMLElement {
  constructor() {
    super();

    this.icon = this.querySelector(".icon");
  }

  connectedCallback() {
    document.addEventListener(
      "storefront:signincompleted",
      this.handleStorefrontSignInCompleted.bind(this),
    );
  }

  handleStorefrontSignInCompleted(event) {
    if (event?.detail?.avatar) {
      this.icon?.replaceWith(event.detail.avatar.cloneNode());
    }
  }
}

customElements.define("account-icon", AccountIcon);

class BulkAdd extends HTMLElement {
  static ASYNC_REQUEST_DELAY = 250;

  constructor() {
    super();
    this.queue = [];
    this.setRequestStarted(false);
    this.ids = [];
  }

  startQueue(id, quantity) {
    this.queue.push({ id, quantity });

    const interval = setInterval(() => {
      if (this.queue.length > 0) {
        if (!this.requestStarted) {
          this.sendRequest(this.queue);
        }
      } else {
        clearInterval(interval);
      }
    }, BulkAdd.ASYNC_REQUEST_DELAY);
  }

  sendRequest(queue) {
    this.setRequestStarted(true);
    const items = {};

    queue.forEach((queueItem) => {
      items[parseInt(queueItem.id)] = queueItem.quantity;
    });
    this.queue = this.queue.filter(
      (queueElement) => !queue.includes(queueElement),
    );

    this.updateMultipleQty(items);
  }

  setRequestStarted(requestStarted) {
    this._requestStarted = requestStarted;
  }

  get requestStarted() {
    return this._requestStarted;
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute("value");
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;

    if (inputValue < event.target.dataset.min) {
      this.setValidity(
        event,
        index,
        window.quickOrderListStrings.min_error.replace(
          "[min]",
          event.target.dataset.min,
        ),
      );
    } else if (inputValue > parseInt(event.target.max)) {
      this.setValidity(
        event,
        index,
        window.quickOrderListStrings.max_error.replace(
          "[max]",
          event.target.max,
        ),
      );
    } else if (inputValue % parseInt(event.target.step) != 0) {
      this.setValidity(
        event,
        index,
        window.quickOrderListStrings.step_error.replace(
          "[step]",
          event.target.step,
        ),
      );
    } else {
      event.target.setCustomValidity("");
      event.target.reportValidity();
      event.target.setAttribute("value", inputValue);
      this.startQueue(index, inputValue);
    }
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }
}

if (!customElements.get("bulk-add")) {
  customElements.define("bulk-add", BulkAdd);
}

class CartPerformance {
  static #metric_prefix = "cart-performance";

  static createStartingMarker(benchmarkName) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`;
    return performance.mark(`${metricName}:start`);
  }

  static measureFromEvent(benchmarkName, event) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`;
    const startMarker = performance.mark(`${metricName}:start`, {
      startTime: event.timeStamp,
    });

    const endMarker = performance.mark(`${metricName}:end`);

    performance.measure(metricName, `${metricName}:start`, `${metricName}:end`);
  }

  static measureFromMarker(benchmarkName, startMarker) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`;
    const endMarker = performance.mark(`${metricName}:end`);

    performance.measure(metricName, startMarker.name, `${metricName}:end`);
  }

  static measure(benchmarkName, callback) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`;
    const startMarker = performance.mark(`${metricName}:start`);

    callback();

    const endMarker = performance.mark(`${metricName}:end`);

    performance.measure(metricName, `${metricName}:start`, `${metricName}:end`);
  }
}

class MerakiModal extends HTMLElement {
  constructor() {
    super();
    this.element = this.getElement();

    this.bindEvents();
  }

  getElement() {
    return {
      closeButton: this.querySelector('.meraki-media-modal__toggle')
    }
  }

  bindEvents() {
    this.element.closeButton.addEventListener('click', this.close.bind(this));
  }

  open() {
    this.setAttribute("open", "");
    this.scrollHidden();
  }

  close() {
    this.removeAttribute("open");
    this.scrollShow();
  }

  scrollHidden() {
    document.body.classList.add("overflow-hidden");
  }

  scrollShow() {
    document.body.classList.remove("overflow-hidden");
  }
}
customElements.define("meraki-modal", MerakiModal);

class MrkCarousel extends HTMLElement {
  constructor() {
    super();

    this.autoChangeTimer = null; // 自动播放
    this.autoChangeTime = 5000; // 自动播放时间
    this.isAutoChange = false; // 自动播放

    this.currentClass = 'active';

    this.isInited = false; // 未初始化
    this.loopTimer = null
    this.connectedCallback();
  }

  init() {
    if (this.isInited) return;
    this.element = this.getElements();

    this.originCount = this.element.originItems.length;
    this.currentIndex = 1;
    this.boxWidth = 0;
    this.itemWidth = 0;
    this.isAnimate = false; // 动画锁：防止快速操作导致错乱

    const computedStyle = window.getComputedStyle(this.element.track);
    this.gapWith = parseFloat(computedStyle.gap) || 0

    this.initCarousel()
  }

  connectedCallback() {
    // 使用全局的IntersectionObserver来进行懒加载初始化
    if (window.merakiUtils && window.merakiUtils.lazyObserver) {
      window.merakiUtils.lazyObserver.observe(this);
    } else {
      // 如果没有懒加载的IntersectionObserver直接初始化，避免组件用不了
      this.init();
    }
  }

  getElements() {
    return {
      carousel: this.querySelector('.mrk-carousel'),
      track: this.querySelector('.carousel-track'),
      prevBtn: this.querySelector('.prevBtn'),
      nextBtn: this.querySelector('.nextBtn'),
      indicators: this.querySelector('.indicators'),
      originItems: this.querySelectorAll('.carousel-item'),
      tabs: this.querySelector('.tabs'),
      tabItems: this.querySelectorAll('.tabs .item')
    }
  }

  // 初始化轮播核心入口
  initCarousel() {
    this.isInited = true;
    // 单轮播项时添加样式类，隐藏按钮和指示器
    if (this.originCount === 1) {
      this.element.carousel.classList.add('carousel-single');
      return;
    }
    if (this.originCount < 2) return;

    this.isAutoChange = !!this.getAttribute('auto-play');

    this.setItemActive()
    this.copyFirstLastNodes(); // 复制首尾节点实现无缝循环
    this.reinitItems(); // 重新获取包含复制节点的轮播项
    this.createIndicators(); // 自动生成指示器
    this.bindAllEvents(); // 统一绑定所有事件
    this.resetTrackPosition(); // 初始化轨道位置

    if (this.isAutoChange) this.handleAutoChange(); // 自动播放
  }

  handleAutoChange() {
    if (!this.autoChangeTimer) {
      this.autoChangeTimer = setInterval(() => {
        if (this.isAnimate) return;
        if (this.currentIndex === this.originCount) {
          this.currentIndex = 1;
        } else {
          this.currentIndex++;
        }
        this.handleOrbitalPosition()
      }, this.autoChangeTime)
    }
  }

  // 切换轨道位置
  handleOrbitalPosition() {
    this.updateCarousel();
  }

  // 复制首尾节点：无缝循环核心
  copyFirstLastNodes() {
    const copyClass = 'copy'
    const lastNode = this.element.originItems[this.originCount - 1].cloneNode(true);
    const lastNode2 = this.element.originItems[this.originCount - 2].cloneNode(true);
    if (lastNode) lastNode.classList.add(copyClass)
    if (lastNode2) lastNode2.classList.add(copyClass)
    this.element.track.insertBefore(lastNode, this.element.track.firstChild);
    this.element.track.insertBefore(lastNode2, this.element.track.firstChild);

    const firstNode = this.element.originItems[0].cloneNode(true);
    const firstNode1 = this.element.originItems[1].cloneNode(true);

    if (firstNode) firstNode.classList.add(copyClass)
    if (firstNode1) firstNode1.classList.add(copyClass)
    this.element.track.appendChild(firstNode);
    this.element.track.appendChild(firstNode1);

    if (window.merakiUtils.lazyYoutubeVideos) {
      const iframeClass = 'iframe.lazy-youtube-load'
      const lastNodeIframe = lastNode.querySelector(iframeClass)
      const lastNode2Iframe = lastNode2.querySelector(iframeClass)
      const firstNodeIframe = firstNode.querySelector(iframeClass)
      const firstNode1Iframe = firstNode1.querySelector(iframeClass)
      if (lastNodeIframe) window.merakiUtils.lazyYoutubeVideos.push(lastNodeIframe)
      if (lastNode2Iframe) window.merakiUtils.lazyYoutubeVideos.push(lastNode2Iframe)
      if (firstNodeIframe) window.merakiUtils.lazyYoutubeVideos.push(firstNodeIframe)
      if (firstNode1Iframe) window.merakiUtils.lazyYoutubeVideos.push(firstNode1Iframe)
    }

    if (window.merakiUtils.lazyImages) {
      const imgClass = 'img.lazy-load[data-src]'
      const lastNodeImg = lastNode.querySelector(imgClass)
      const lastNode2Img = lastNode2.querySelector(imgClass)
      const firstNodeImg = firstNode.querySelector(imgClass)
      const firstNode1Img = firstNode1.querySelector(imgClass)
      if (lastNodeImg) window.merakiUtils.lazyImages.push(lastNodeImg)
      if (lastNode2Img) window.merakiUtils.lazyImages.push(lastNode2Img)
      if (firstNodeImg) window.merakiUtils.lazyImages.push(firstNodeImg)
      if (firstNode1Img) window.merakiUtils.lazyImages.push(firstNode1Img)
    }

    if (window.merakiUtils.lazyVideos) {
      const videoClass = 'video.lazy-video-load'
      const lastNodeVideo = lastNode.querySelector(videoClass)
      const lastNode2Video = lastNode2.querySelector(videoClass)
      const firstNodeVideo = firstNode.querySelector(videoClass)
      const firstNode1Video = firstNode1.querySelector(videoClass)
      if (lastNodeVideo) window.merakiUtils.lazyVideos.push(lastNodeVideo)
      if (lastNode2Video) window.merakiUtils.lazyVideos.push(lastNode2Video)
      if (firstNodeVideo) window.merakiUtils.lazyVideos.push(firstNodeVideo)
      if (firstNode1Video) window.merakiUtils.lazyVideos.push(firstNode1Video)
    }
  }

  // 重新初始化轮播项（含复制节点）并计算宽度
  reinitItems() {
    this.element.originItems = this.querySelectorAll('.carousel-item');
    
    this.boxWidth = this.element.track.getBoundingClientRect().width;
    this.itemWidth = this.element.originItems[0].getBoundingClientRect().width;
  }

  // 自动生成指示器
  createIndicators() {
    if (this.element.indicators) {
      this.element.indicators.innerHTML = '';
      for (let i = 0; i < this.originCount; i++) {
        const dot = document.createElement('span');
        dot.className = `indicator-dot ${i === 0 ? 'active' : ''}`;
        dot.addEventListener('click', () => {
          if (this.isAnimate) return;
          this.currentIndex = i + 1;
          this.updateCarousel();
        });
        this.element.indicators.appendChild(dot);
      }
    }
  }

  // 核心更新方法：滑动+指示器+循环判断
  updateCarousel() {
    this.isAnimate = true; // 开启动画锁

    const widthPoor = (this.boxWidth - this.itemWidth)
    const marginPoor = widthPoor / 2
    const translateX = -(this.currentIndex + 1) * this.itemWidth + marginPoor - this.gapWith * (this.currentIndex + 1);
    this.element.track.style.transition = `all .3s`;
    this.element.track.style.transform = `translateX(${translateX}px)`;
    this.updateIndicators();
    // 动画结束后处理循环，单次监听防止重复触发
    clearTimeout(this.loopTimer)
    this.loopTimer = setTimeout(() => {
      this.handleLoop()
      clearTimeout(this.loopTimer)
    }, 300)
    // this.element.track.addEventListener('transitionend', this.handleLoop.bind(this), { once: true });
    this.setCuurent()
  }

  // 设置 高亮
  setItemActive() {
    if (this.element.tabItems && this.element.tabItems.length) {
      this.element.tabItems.forEach(item => {
        item.classList.remove(this.currentClass);
      })
      const itemNode = this.element.tabItems[this.currentIndex - 1]
      itemNode.classList.add(this.currentClass);
    }
  }

  // 无缝循环处理：到达复制节点时瞬间切回原节点
  handleLoop() {
    if (this.currentIndex === 0) {
      this.currentIndex = this.originCount;
      this.resetTrackPosition();
    } else if (this.currentIndex === this.originCount + 1) {
      this.currentIndex = 1;
      this.resetTrackPosition();
    }
    this.isAnimate = false; // 关闭动画锁

    this.setItemActive()
  }

  // 重置轨道位置：无过渡瞬间跳转（循环/窗口缩放用）
  resetTrackPosition() {
    this.element.track.style.transition = 'none';
    const widthPoor = (this.boxWidth - this.itemWidth)
    const marginPoor = widthPoor / 2
    const translateX = -(this.currentIndex + 1) * this.itemWidth + marginPoor - this.gapWith * (this.currentIndex + 1);
    this.element.track.style.transform = `translateX(${translateX}px)`;
    void this.element.track.offsetWidth; // 强制重绘，防止过渡失效
    this.setCuurent()
  }

  // 统一绑定所有事件（修复点击核心：全用addEventListener）
  bindAllEvents() {
    // 左右按钮点击事件（统一用DOM2级绑定，无覆盖）
    if (this.element.prevBtn) {
      this.element.prevBtn.addEventListener('click', () => {
        if (this.isAnimate) return;
        if (this.currentIndex === 1) return;
        this.currentIndex--;
        this.updateCarousel();
      });
    }

    if (this.element.nextBtn) {
      this.element.nextBtn.addEventListener('click', () => {
        if (this.isAnimate) return;
        if (this.currentIndex === this.originCount) return;
        this.currentIndex++;
        this.updateCarousel();
      });
    }

    // 移动端滑动事件
    let startX = 0, moveX = 0, isMoving = false, startY = 0;
    this.element.track.addEventListener('touchstart', (e) => {
      if (this.isAnimate) return;
      isMoving = true;
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      this.element.track.style.transition = 'none'; // 滑动中关闭过渡，提升流畅度
    });

    this.element.track.addEventListener('touchmove', (e) => {
      if (!isMoving || this.isAnimate) return;
      moveX = e.touches[0].clientX - startX;
      const deltaY = e.touches[0].clientY - startY;
      const widthPoor = (this.boxWidth - this.itemWidth)
      const marginPoor = widthPoor / 2
      const translateX = -(this.currentIndex + 1) * this.itemWidth + marginPoor - this.gapWith * (this.currentIndex + 1);
      this.element.track.style.transform = `translateX(${translateX}px)`;
      if (Math.abs(moveX) > Math.abs(deltaY)) {
        e.preventDefault();
      }
    }, { passive: false });

    this.element.track.addEventListener('touchend', () => {
      if (!isMoving || this.isAnimate) return;
      isMoving = false;
      this.element.track.style.transition = 'transform 0.3s ease-out';
      const threshold = this.itemWidth * 0.2; // 滑动阈值：30%宽度
      if (moveX > threshold) this.currentIndex--;
      else if (moveX < -threshold) this.currentIndex++;
      this.updateCarousel();
      startX = 0;
      moveX = 0;
    });

    this.element.track.addEventListener('touchcancel', () => {
      if (!isMoving || this.isAnimate) return;
      isMoving = false;
      this.element.track.style.transition = 'transform 0.3s ease-out';
      const threshold = this.itemWidth * 0.2; // 滑动阈值：30%宽度
      if (moveX > threshold) this.currentIndex--;
      else if (moveX < -threshold) this.currentIndex++;
      this.updateCarousel();
      startX = 0;
      moveX = 0;
    });

    // 窗口大小变化适配
    window.addEventListener('resize', () => {
      if (this.isAnimate) return;
      const computedStyle = window.getComputedStyle(this.element.track);
      this.gapWith = parseFloat(computedStyle.gap) || 0
      this.reinitItems();
      this.resetTrackPosition();
    });

    // tab 切换
    if (this.element.tabs) {
      this.element.tabs.addEventListener('click', (e) => {
        const itemNode = e.target.closest('.item')
        const itemIndex = parseFloat(itemNode.getAttribute('data-index'))
        if (this.isAnimate) return;
        if (this.currentIndex === itemIndex) return;
        this.currentIndex = itemIndex;
        this.updateCarousel();
      });
    }
    
  }

  // 更新指示器激活状态
  updateIndicators() {
    const dots = this.element.carousel.querySelectorAll('.indicator-dot');
    let activeIndex = 0;
    if (this.currentIndex === 0) activeIndex = this.originCount - 1;
    else if (this.currentIndex === this.originCount + 1) activeIndex = 0;
    else activeIndex = this.currentIndex - 1;
    dots.forEach((dot, index) => {
      dot.className = `indicator-dot ${index === activeIndex ? 'active' : ''}`;
    });
  }

  // 设置当前 item 高亮
  setCuurent() {
    // this.element.originItems[this.originCount - 1]
    this.element.originItems.forEach((item, index) => {
      if (index + 1 === this.currentIndex + 2) {
        item.classList.add('active')
      } else {
        item.classList.remove('active')
      }
    })

    if (this.element.nextBtn) {
      if (this.currentIndex >= this.element.originItems.length - 4) {
        this.element.nextBtn.classList.add('disable')
      } else {
        this.element.nextBtn.classList.remove('disable')
      }
    }

    if (this.element.prevBtn) {
      if (this.currentIndex <= 1) {
        this.element.prevBtn.classList.add('disable')
      } else {
        this.element.prevBtn.classList.remove('disable')
      }
    }
  }
}
customElements.define("mrk-carousel", MrkCarousel);

class MerakiCarouselSwitch extends HTMLElement {
  // 轮播切换，只会pc端切换
  // 示例(源码和样式)可以参考 sections\meraki-espresso-dual-boiler.liquid
  constructor() {
    super();
    this.DESKTOP_BREAKPOINT = 990;
    this.TRANSITION = 'cubic-bezier(0.45, 0, 0.73, 1)';
    this.window_innerWidth = window.innerWidth || document.documentElement.clientWidth
    this.carouselConfig = {
      itemWidth: this.window_innerWidth * 0.6 || 1068,
      gap: 20,
      initialOffset: 0,
      speed: 200
    };
    this.carouselState = {
      desktopReady: false,
      isAnimating: false,
      pendingDirection: null,
      resizeTimer: null
    };
    this.desktopSectionObserver = null;

    this.element = this.getElement();
    this.init();
  }
  getElement() {
    return {
      track: this.querySelector('.sell-points-track'),
      prevButton: this.querySelector('.sell-point-nav-prev'),
      nextButton: this.querySelector('.sell-point-nav-next'),
      originalSlides: Array.from(this.querySelectorAll('.sell-point-item'))
    }
  }
  init() {
    if (!this.element.track || !this.element.prevButton || !this.element.nextButton || this.element.originalSlides.length === 0) return;

    this.bindEvents();
  }
  bindEvents() {
    this.element.track.addEventListener('transitionend', this.handleTransitionEnd.bind(this));
    this.element.prevButton.addEventListener('click', this.movePrevDesktop.bind(this));
    this.element.nextButton.addEventListener('click', this.moveNextDesktop.bind(this));

    this.handleResize();
    window.addEventListener('resize', () => {
      clearTimeout(this.carouselState.resizeTimer);
      this.carouselState.resizeTimer = setTimeout(() => {
        this.carouselState.isAnimating = false;
        this.carouselState.pendingDirection = null;
        this.handleResize();
      }, 120);
    });
  }
  
  isDesktopView() {
    return this.window_innerWidth >= this.DESKTOP_BREAKPOINT;
  }

  getScaleFactor() {
    return Math.min(this.window_innerWidth / 1920, 1);
  }

  getSlideWidth() {
    return (this.carouselConfig.itemWidth + this.carouselConfig.gap) * this.getScaleFactor();
  }

  getBaseTranslate() {
    return this.carouselConfig.initialOffset * this.getScaleFactor();
  }

  applyTransform(value, animated) {
    this.element.track.style.transition = animated ? `transform ${this.carouselConfig.speed}ms ${this.TRANSITION}` : 'none';
    this.element.track.style.transform = `translate3d(${value}px, 0, 0)`;
    if (!animated) {
      this.element.track.getBoundingClientRect(); // 强制回流避免闪烁
    }
  }

  restoreOriginalOrder() {
    this.element.originalSlides.forEach(slide => {
      this.element.track.appendChild(slide);
    });
  }

  setNavAvailability(isEnabled) {
    [this.element.prevButton, this.element.nextButton].forEach(button => {
      if (isEnabled) {
        button.classList.remove('disabled');
        button.removeAttribute('disabled');
      } else {
        button.classList.add('disabled');
        button.setAttribute('disabled', 'disabled');
      }
    });
  }

  enableDesktopCarousel() {
    if (this.carouselState.desktopReady) {
      this.carouselState.isAnimating = false;
      this.carouselState.pendingDirection = null;
      this.applyTransform(this.getBaseTranslate(), false);
      this.setNavAvailability(true);
      return;
    }

    this.restoreOriginalOrder();
    this.carouselState.desktopReady = true;
    this.carouselState.isAnimating = false;
    this.carouselState.pendingDirection = null;
    this.setNavAvailability(true);
    this.applyTransform(this.getBaseTranslate(), false);
  }

  moveNextDesktop() {
    if (!this.carouselState.desktopReady || this.carouselState.isAnimating) return;
    this.carouselState.isAnimating = true;
    this.carouselState.pendingDirection = 'next';
    const target = this.getBaseTranslate() - this.getSlideWidth();
    this.applyTransform(target, true);
  }

  movePrevDesktop() {
    if (!this.carouselState.desktopReady || this.carouselState.isAnimating) return;

    const slides = this.element.track.querySelectorAll('.sell-point-item');
    if (!slides.length) return;

    const lastSlide = slides[slides.length - 1];
    this.element.track.insertBefore(lastSlide, slides[0]);

    const startPosition = this.getBaseTranslate() - this.getSlideWidth();
    this.applyTransform(startPosition, false);

    this.carouselState.isAnimating = true;
    this.carouselState.pendingDirection = 'prev';
    requestAnimationFrame(() => {
      this.applyTransform(this.getBaseTranslate(), true);
    });
  }

  handleTransitionEnd(event) {
    if (!this.carouselState.desktopReady || event.target !== this.element.track || !this.carouselState.pendingDirection) {
      return;
    }

    if (this.carouselState.pendingDirection === 'next') {
      const firstSlide = this.element.track.querySelector('.sell-point-item');
      if (firstSlide) {
        this.element.track.appendChild(firstSlide);
      }
    }

    this.carouselState.pendingDirection = null;
    this.carouselState.isAnimating = false;
    this.applyTransform(this.getBaseTranslate(), false);
  }

  handleResize() {
    if (this.isDesktopView()) {
      this.enableDesktopCarousel();
    }
  }
}
customElements.define("meraki-carousel-switch", MerakiCarouselSwitch);

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
    summary.setAttribute("role", "button");
    summary.setAttribute(
      "aria-expanded",
      summary.parentNode.hasAttribute("open"),
    );

    if (summary.nextElementSibling && summary.nextElementSibling.getAttribute("id")) {
      summary.setAttribute("aria-controls", summary.nextElementSibling.id);
    }

    summary.addEventListener("click", (event) => {
      event.currentTarget.setAttribute(
        "aria-expanded",
        !event.currentTarget.closest("details").hasAttribute("open"),
      );
    });

    if (summary.closest("header-drawer, menu-drawer")) return;
    summary.parentElement.addEventListener("keyup", onKeyUpEscape);
  });

  // Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
  try {
    document.querySelector(":focus-visible");
  } catch (e) {
    focusVisiblePolyfill();
  }

  if (window.merakiUtils.scrollToAnchor) {
    window.addEventListener('hashchange', window.merakiUtils.scrollToAnchor)
  }

  function observeVideos() {
    const videoBlocks = document.querySelectorAll('.function-bundle-section-blocks video');
    const observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0.5,
    };
    const videoObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const video = entry.target;
        if (entry.isIntersecting) {
          video.play();
        } else {
          video.pause();
        }
      });
    }, observerOptions);

    videoBlocks.forEach((video) => {
      videoObserver.observe(video);
    });
  }
  observeVideos();

  if (window.merakiUtils.loadVisibleResource) {
    // 初始加载：页面加载完成后检查一次
    window.merakiUtils.loadVisibleResource();
    // 节流后监听scroll/resize事件
    window.addEventListener('scroll', window.merakiUtils.throttle(window.merakiUtils.loadVisibleResource));
    window.addEventListener('resize', window.merakiUtils.throttle(window.merakiUtils.loadVisibleResource));
  }

  // if (window.merakiUtils.autoOpenRegionSelector) {
  //   window.merakiUtils.autoOpenRegionSelector()
  // }

  // (function(c,l,r){
  //   function getParamValue(url = window.location.href, paramName = 'campaign_id', paramValue = '120237990691040003') {
  //     const urlObj = new URL(url);
  //     const value = urlObj.searchParams.get(paramName);
  //     return value !== null && value === paramValue;
  //   }
  //   if (getParamValue()) {
  //     let t = l.createElement(r);t.async=1;t.src="https://www.googletagmanager.com/gtag/js?id=G-XP3NY38T7Q";
  //     let y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
  //     window.dataLayer = window.dataLayer || [];
  //     function gtag(){dataLayer.push(arguments);}
  //     gtag('js', new Date());
  //     gtag('config', 'G-XP3NY38T7Q');

  //     var devTimer = null
  //     devTimer = setTimeout(function () {
  //       gtag('event', 'view_item_campaign', {
  //         'event_text': '120237990691040003',
  //         'page_url': window.location.href
  //       })
  //       clearTimeout(devTimer)
  //       devTimer = null
  //     }, 3000)
  //   }
  // })(window, document, 'script');
});